import { Dinero } from 'dinero.js'
import React from 'react'
import NumberFormat from 'react-number-format'

interface IPriceProps {
  value: Dinero | number | string
  currency?: string
  allowReservationEdit?: boolean
}

const Price = ({
  value,
  currency,
  allowReservationEdit = true,
}: IPriceProps) => {
  //console.log(value, currency)
  const val =
    typeof value === 'number' || typeof value === 'string'
      ? value
      : value? value.toFormat('0.00'): '0.00'
  const numericString = typeof val === 'string'

  return (
    <>
      <NumberFormat
        thousandSeparator={' '}
        decimalSeparator={','}
        decimalScale={2}
        fixedDecimalScale={true}
        disabled={!allowReservationEdit}
        value={val}
        isNumericString={numericString}
        displayType={'text'}
      />
      {currency && ` ${currency}`}
    </>
  )
}

export default Price
